import { createWebInstance } from '@yuanfudao/metis-infra-frog'
import { FrogEnv } from '@yuanfudao/infra-frog/web'
import config from '@/config'
import { useRecoilValue } from 'recoil'
import { currentAccountAtom } from '@/store/home'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

const env = process.env.REACT_APP_ENV === 'online' ? FrogEnv.ONLINE : FrogEnv.TEST

export const frog = createWebInstance({
  appId: config.FROG.APPID, // appId，需要向数据中台申请
  appToken: config.FROG.TOKEN, // token，需要向数据中台申请
  env, // 运行环境
  getTimestamp: () => Date.now(), // 获取当前时间接口
  debug: false, // 是否开启 debug 模式，打印详细日志，默认关闭
  // immediate: true // 是否立即上传日志，web端默认直接上传，其他端默认先缓存
})

export function useInitFrog() {
  const currentAccount = useRecoilValue(currentAccountAtom)

  useEffect(() => {
    if (currentAccount) {
      frog.init({
        originUserId: 0,
        primaryUserId: 0,
        userId: +currentAccount.username,
        productId: config.FROG.PRODUCT_ID,
        appVersion: '1.0.0',
      })
    }
  }, [currentAccount])
}

export function useAddFrog(url: string, eventId: number) {
  const currentAccount = useRecoilValue(currentAccountAtom)
  const { formid, id } = useParams<{ id: string, formid: string }>()
  useEffect(() => {
    const start = Date.now()
    let params: { schoolId: number, collectionId: number, moduleId?: number, userAgent: string } | null = null
    if (currentAccount && formid) {
      params = {
        userAgent: navigator.userAgent,
        schoolId: currentAccount.tenantId,
        collectionId: +formid,
      }
      if (id) {
        params.moduleId = +id
      }
    }
    return () => {
      if (params) {
        console.debug('发送了', {
          timeOnPage: `${Math.ceil((Date.now() - start) / 1000)}秒`,
          ...params,
        })
        frog.add({
          url,
          eventId,
          customExtend: {
            timeOnPage: Date.now() - start,
            ...params,
          },
        })
      }
    }
  }, [currentAccount, eventId, formid, id, url])
}
